module.exports = __webpack_public_path__ + "img/landing_box36.137a6263.jpg";